import { render, staticRenderFns } from "./FandyWidget.vue?vue&type=template&id=2500917a&scoped=true&"
import script from "./FandyWidget.vue?vue&type=script&lang=js&"
export * from "./FandyWidget.vue?vue&type=script&lang=js&"
import style0 from "./FandyWidget.vue?vue&type=style&index=0&id=2500917a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500917a",
  null
  
)

export default component.exports